import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { RouterLink } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { SvgIconComponent } from "@shared/components/svg-icons/svg-icons.component";
import { NOUS_CONTACTER } from "@shared/constants/route.constants";
import { HandlerPhoneEmail } from "@shared/models/handler-phone-email.model";
import { HandlerService } from "@shared/services/handler.service";
import { ButtonModule } from "primeng/button";
import { OverlayPanelModule } from "primeng/overlaypanel";

@Component({
  selector: "app-contact-phone",
  standalone: true,
  imports: [CommonModule, ButtonModule, OverlayPanelModule, TranslateModule, RouterLink, SvgIconComponent],
  templateUrl: "./contact-phone.component.html",
  styleUrls: ["./contact-phone.component.scss"],
  providers: [HandlerService],
})
export class ContactPhoneComponent implements OnInit {
  constructor(private handlerService: HandlerService) {}

  handler: HandlerPhoneEmail | undefined;
  public NOUS_CONTACTER = NOUS_CONTACTER;

  ngOnInit() {
    this.handlerService.getHandler().subscribe(
      data => {
        this.handler = data;
      },
      error => {
        console.error(error);
      }
    );
  }
}
